import { Definition } from '../store/definitions/definition.interface';

export const ROLE_WHOLESALER = 'Wholesaler';
export const ROLE_END_USER = 'End User';
export const ROLE_INTERMEDIATE = 'Intermediate';

export interface HomeMarketBonus {
  sender: Definition;
  receiver: Definition;
  senderRole?: string;
  receiverRole?: string;
  activeFrom: Date;
  activeTo?: Date;
  isActive: boolean;
}

export interface HomeMarketBonusListTO {
  totalCount: number;
  data: HomeMarketBonusTO[]
}

export interface HomeMarketBonusListShipTosTO {
  senderShipTos?: Definition[];
  receiverShipTos?: Definition[];
  failed: boolean;
  loading: boolean;
}
export interface HomeMarketBonusTO {
  senderShipTo: string,
  senderNameShipTo: string,
  senderRole: string,
  receiverShipTo: string,
  receiverNameShipTo: string,
  receiverRole: string,
  activeFrom: string;
  activeTo?: string;
  isActive: boolean;
}

export interface HomeMarketBonusPagingQuery extends HomeMarketBonusQuery {
  pageNumber: number;
  pageSize: number;
  sortKey?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export interface HomeMarketBonusQuery {
  senderShipToIds: string[];
  receiverShipToIds: string[];
  receiverRoles: string[];
  substring: string;
  isActive: boolean;
}

export function mapTOToHomeMarketBonus(to: HomeMarketBonusTO): HomeMarketBonus {
  return {
    activeFrom: toDateOrUndefined(to.activeFrom),
    activeTo: toDateOrUndefined(to.activeTo),
    isActive: to.isActive,
    receiver: {
      id: to.receiverShipTo,
      name: to.receiverNameShipTo,
    },
    receiverRole: to.receiverRole,
    sender: {
      id: to.senderShipTo,
      name: to.senderNameShipTo
    },
    senderRole: to.senderRole
  }
}

function toDateOrUndefined(dateOrDefault?: string): Date | undefined {
  if (dateOrDefault) {
    const date = new Date(dateOrDefault);
    if (date.getTime() <= 0) {
      return undefined;
    }
    return date;
  }
}
